import React, { Component } from 'react';
import { Container, Button } from 'react-bootstrap';
import MenuLeftCMS from './ct-fragmentsidemenu';
import { GetText, ReplaceInsText, ReplaceText } from '../config/helper';
import '../config/global';
import CTNA from './ct-fragmentna';
import { FormErrors } from '../inc/error-form';
import Error404 from '../Error404';

const authKey = global.config.kindcode.training[18]+global.config.authBearerKey;
const authKey2 = global.config.kindcode.training[17]+global.config.authBearerKey;

export default class CTTutorForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activelink:"none",
      paramlink: "",
      stTitle: "",
      stories_docid: "",
      stories_name: "",
      stories_email: "",
      stories_position: "",
      stories_company: "",
      stories_type: "",
      stories_message: "",
      stories_status: "",
      stories_language: "",
      stories_number: "",
      stories_in_docid: "",
      stories_in_content: "",
      formErrors: {stories_name: '', stories_email: '', stories_position: '', stories_company: '', stories_type: '', stories_message:'', stories_status: "", stories_language: '', stories_number: ''},
      storiesnameValid: false,
      storiesemailValid: false,
      storiespositionValid: false,
      storiescompanyValid: false,
      storiestypeValid: false,
      storiesmessageValid: false,
      storiesstatusValid: false,
      storieslanguageValid: false,
      storiesnumberValid: false,
      formValid: false,
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleBack = (currpage,param) => {
    var backurl = global.config.urlCms+"/"+currpage;
    if(param === "inc") { 
      backurl += "/incoming";
    } else if(param === "eng") { 
      backurl += "/english";
    } else {
      backurl += "/indonesia";
    }
    window.location.href = backurl;
  }
  handleUserInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
        [name]: value
    }, () => {
        this.validateField(name, value)
    });
  }    
  handleUserSelect = (e) => {
    const name = e.target.name; 
    const value = e.target.value;
    this.setState(prevState => {
        return {  
            ...prevState[name], [name]: value
        }
    }, () => { 
        this.validateField(name, value)
    });
  }
  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let storiesnameValid = this.state.storiesnameValid;
    let storiesemailValid = this.state.storiesemailValid;
    let storiespositionValid = this.state.storiespositionValid;
    let storiescompanyValid = this.state.storiescompanyValid;
    let storiestypeValid = this.state.storiestypeValid;
    let storiesmessageValid = this.state.storiesmessageValid;
    let storiesstatusValid = this.state.storiesstatusValid;
    let storieslanguageValid = this.state.storieslanguageValid;
    let storiesnumberValid = this.state.storiesnumberValid;
    switch(fieldName) {
        case 'stories_name': 
            storiesnameValid = value.trim().length > 0;
            fieldValidationErrors.stories_name = storiesnameValid ? '' : 'name need to be filled';
            break;
        case 'stories_email': 
            storiesemailValid = value.trim().length > 0;
            fieldValidationErrors.stories_email = storiesemailValid ? '' : 'email need to be filled';
            break;
        case 'stories_position': 
            storiespositionValid = value.trim().length > 0;
            fieldValidationErrors.stories_position = storiespositionValid ? '' : 'position / job title need to be filled';
            break;
        case 'stories_company': 
            storiescompanyValid = value.trim().length > 0;
            fieldValidationErrors.stories_company = storiescompanyValid ? '' : 'company need to be filled';
            break;
        case 'stories_type': 
            storiestypeValid = value.trim().length > 0;
            fieldValidationErrors.stories_type = storiestypeValid ? '' : 'type need to be filled';
            break;
        case 'stories_number': 
            storiesnumberValid = value.trim().length > 0;
            fieldValidationErrors.stories_number = storiesnumberValid ? '' : 'sort number need to be filled';
            break;
        case 'stories_language': 
            storieslanguageValid = value.trim().length > 0;
            fieldValidationErrors.stories_language = storieslanguageValid ? '' : 'language need to be filled';
            break;
        case 'stories_message': 
            storiesmessageValid = value.trim().length > 0;
            fieldValidationErrors.stories_message = storiesmessageValid ? '' : 'message need to be filled';
            break;
        case 'stories_status': 
            storiesstatusValid = value.trim().length > 0;
            fieldValidationErrors.stories_status = storiesstatusValid ? '' : 'status need to be filled';
            break;
        default:
            break;
    }    
    this.setState({
        formErrors: fieldValidationErrors,
        storiesnameValid: storiesnameValid,
        storiesemailValid: storiesemailValid,
        storiespositionValid: storiespositionValid,
        storiescompanyValid: storiescompanyValid,
        storiestypeValid: storiestypeValid,
        storiesmessageValid: storiesmessageValid,
        storiesstatusValid: storiesstatusValid,
        storieslanguageValid: storieslanguageValid,
        storiesnumberValid: storiesnumberValid
    }, this.validateForm);
  }
  vvalidateForm() {
    this.setState({
        formValid: this.state.storiesnameValid && this.state.storiesemailValid && this.state.storiespositionValid && this.state.storiescompanyValid && this.state.storiestypeValid && 
        this.state.storiesmessageValid && this.state.storiesstatusValid && this.state.storieslanguageValid && this.state.storiesnumberValid 
    });
  }
  errorClass(error) {
    return(error.length === 0 ? '' : 'has-error');
  }
  
  handleSubmit(e) {
    e.preventDefault();   
    if(this.state.stories_name !== '' && this.state.stories_email !== '' && this.state.stories_message !== '' && this.state.stories_number !== '' && this.state.stories_status !== '' && this.state.stories_language !== '' && this.state.stories_type !== '') {
        document.getElementById('loading-area').style.display = 'block'; 
        var urlFetch, datatext;
        var storiesName,storiesEmail,storiesPosition,storiesCompany,storiesType,storiesMessage,storiesLanguage,storiesNumber,storiesStatus;
        if(this.textInputStoriesName.value === '') { storiesName = this.state.stories_name; } else { storiesName = this.textInputStoriesName.value; }
        if(this.textInputStoriesEmail.value === '') { storiesEmail = this.state.stories_email; } else { storiesEmail = this.textInputStoriesEmail.value; }
        if(this.textInputStoriesPosition.value === '') { storiesPosition = this.state.stories_position; } else { storiesPosition = this.textInputStoriesPosition.value; }
        if(this.textInputStoriesCompany.value === '') { storiesCompany = this.state.stories_company; } else { storiesCompany = this.textInputStoriesCompany.value; }
        if(this.textInputStoriesType.value === '') { storiesType = this.state.stories_type; } else { storiesType = this.textInputStoriesType.value; }
        if(this.textInputStoriesLanguage.value === '') { storiesLanguage = this.state.stories_language; } else { storiesLanguage = this.textInputStoriesLanguage.value; }
        if(this.textInputStoriesNumber.value === '') { storiesNumber = this.state.stories_number; } else { storiesNumber = this.textInputStoriesNumber.value; }
        if(this.textInputStoriesStatus.value === '') { storiesStatus = this.state.stories_status; } else { storiesStatus = this.textInputStoriesStatus.value; }
        
        if(this.textInputStoriesMessage.value === '') { storiesMessage = this.state.stories_message; } else { storiesMessage = this.textInputStoriesMessage.value; }
        storiesMessage = ReplaceInsText(storiesMessage);
        storiesStatus = storiesStatus === 'Active' ? 1 : 0;
            
        var datatext='{';
        datatext += '"stories_name":"'+storiesName+'","stories_email":"'+storiesEmail+'","stories_position":"'+storiesPosition+'","stories_company":"'+storiesCompany+'","stories_message":"'+storiesMessage+'","stories_type":"'+storiesType+'","stories_status":'+storiesStatus+',"stories_language":"'+storiesLanguage+'","stories_sort_num":'+storiesNumber;
        if(this.state.stories_docid !== null && this.state.stories_docid !== ''  && this.state.stories_docid !== undefined) { 
            datatext += ',"stories_docid":"'+this.state.stories_docid+'","form_id":"form-edit"';
            urlFetch = global.config.urlLink+"/storiesedit";
        } else {
            if(this.state.stories_in_docid !== undefined && this.state.stories_in_docid !== "") { datatext +=',"stories_incoming_id":"'+this.state.stories_in_docid+'"'; }
            if(this.state.stories_in_content !== undefined && this.state.stories_in_content !== "") { datatext +=',"stories_incoming_content":'+this.state.stories_in_content; }
            
            datatext +=',"form_id":"form-add"';
            urlFetch = global.config.urlLink+"/storiesadd";
        }
        datatext += '}'
        var data = JSON.parse(datatext);
        fetch(urlFetch, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': authKey,
            }, body : JSON.stringify(data)
        }).then(res => {
            if(res.status === 200) 
                return res.json() 
        }).then( resJson => {
            if(resJson.status === '200') {
              var docId = resJson.values;
              if(this.state.stories_in_docid !== undefined && this.state.stories_in_docid !== "") { 
                var datatext ='{"stories_status":"'+global.config.storiesinStatus[1]+'","stories_docid":"'+this.state.stories_in_docid+'","stories_publish_id":"'+docId+'","form_id":"form-publish"}';
                var urlFetch = global.config.urlLink+"/storiesinedit";
                var data = JSON.parse(datatext);
                fetch(urlFetch, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': authKey2,
                    }, body : JSON.stringify(data)
                }).then(res => {
                    if(res.status === 200)
                        return res.json() 
                }).then( resJson => {
                    if(resJson.status === '200') {
                      window.location.href=global.config.urlCms+"/"+this.state.activelink+"/view/"+docId;
                    } else {
                        console.log('Something happened wrong');
                    }
                    
                })
              } else {
                window.location.href=global.config.urlCms+"/"+this.state.activelink+"/view/"+docId;
              } 
            } else {
                console.log('Something happened wrong');
            }

            document.getElementById('loading-area').style.display = 'none'; 
            
        }).catch(err => { 
            document.getElementById('loading-area').style.display = 'none'; 
        });
    
    } else {
        var arrfieldName = ['stories_name','stories_email','stories_message','stories_status','stories_language','stories_type','stories_number'];
        var arrvalue = [this.textInputStoriesName.value,this.textInputStoriesEmail.value,this.textInputStoriesMessage.value,this.textInputStoriesStatus.value,this.textInputStoriesLanguage.value,this.textInputStoriesType.value,this.state.textInputStoriesNumber];
        for(var ck in arrfieldName) {
            this.validateField(arrfieldName[ck], arrvalue[ck]);
        }
    }
    
  }
  

  loadData(currpage,typelink,docid) {
    if(typelink === 'edit') {
        if(docid !== '') { 
            document.getElementById('loading-area').style.display = 'block';
            fetch(global.config.urlLink+"/storiesview/"+docid, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': authKey,
                }
                }).then(res => {
                if(res.status === 200) 
                    return res.json() 
                }).then( resJson => {
                  document.getElementById('loading-area').style.display = 'none';
                  if(resJson.status === '200') {
                    if(resJson.values[0].content[0].maincontent !== undefined) {
                    
                      var resultContent = resJson.values[0].content[0].maincontent;
                      var lName = "", lEmail = "", lPosition = "", lMessage = "", lCompany = "", lType="", lStatus = "", lLanguage="", lNumber = 0;

                      if (resultContent.storiesName !== undefined) { lName = resultContent.storiesName; }
                      if (resultContent.storiesEmail !== undefined) { lEmail = resultContent.storiesEmail; }
                      if (resultContent.storiesPosition !== undefined) { lPosition = resultContent.storiesPosition; }
                      if (resultContent.storiesCompany !== undefined) { lCompany = resultContent.storiesCompany; }
                      if (resultContent.storiesType !== undefined) { lType = resultContent.storiesType; }
                      if (resultContent.storiesLanguage !== undefined) { lLanguage = resultContent.storiesLanguage; }
                      if (resultContent.storiesSortNumber !== undefined) { lNumber = resultContent.storiesSortNumber; }
                      if (resultContent.storiesMessage !== undefined) {
                        lMessage = ReplaceText(resultContent.storiesMessage);
                      }
                      
                      if (resultContent.status !== undefined) {
                        lStatus = resultContent.status === 1 ? "Active" : "Inactive";
                      }
                      this.setState({
                          activelink: currpage,
                          paramlink: lLanguage === "Indonesian"? "idn" : "eng",
                          stTitle: GetText() ? "Edit Kisah Sukses" : "Edit Success Stories",
                          stories_docid: resJson.values[0].docid,
                          stories_name: lName,
                          stories_email: lEmail,
                          stories_position: lPosition,
                          stories_company: lCompany,
                          stories_type: lType,
                          stories_message: lMessage,
                          stories_status: lStatus,
                          stories_language: lLanguage,
                          stories_number: lNumber,
                          formErrors: {stories_name: '', stories_email: '', stories_position: '', stories_company: '', stories_type: '', stories_message:'', stories_status: "", stories_language: '', stories_number: ''},
                          storiesnameValid: false,
                          storiesemailValid: false,
                          storiespositionValid: false,
                          storiescompanyValid: false,
                          storiestypeValid: false,
                          storiesmessageValid: false,
                          storiesstatusValid: false,
                          storieslanguageValid: false,
                          storiesnumberValid: false,
                          formValid: false,
                      }) 
                    } else {
                      window.location.href=global.config.urlCms+"/"+currpage+"/add";
                    }
                  } else {
                    console.log('Something wrong happened');
                  }
                }).catch(err => err);
        } else {
          this.setState( prevState => {
            return {
              ...prevState.activelink, activelink: currpage,
              ...prevState.stTitle, stTitle:  GetText() ? "Edit Kisah Sukses" : "Edit Success Stories",
            }
          })
        }
      } else if(typelink === 'addin') {
        if(docid !== '') { 
            document.getElementById('loading-area').style.display = 'block';
            fetch(global.config.urlLink+"/storiesinview/"+docid, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': authKey2,
                }
                }).then(res => {
                if(res.status === 200) 
                    return res.json() 
                }).then( resJson => {
                  document.getElementById('loading-area').style.display = 'none';
                  if(resJson.status === '200') {
                    if(resJson.values[0].content[0].maincontent !== undefined) {
                    
                      var resultContent = resJson.values[0].content[0].maincontent;
                      var lName = "", lEmail = "", lPosition = "", lMessage = "", lCompany = "", lType="", lStatus = "", lLanguage="", lNumber = 0;

                      if (resultContent.storiesName !== undefined) { lName = resultContent.storiesName; }
                      if (resultContent.storiesEmail !== undefined) { lEmail = resultContent.storiesEmail; }
                      if (resultContent.storiesPosition !== undefined) { lPosition = resultContent.storiesPosition; }
                      if (resultContent.storiesCompany !== undefined) { lCompany = resultContent.storiesCompany; }
                      if (resultContent.storiesType !== undefined) { lType = resultContent.storiesType; }
                      if (resultContent.storiesLanguage !== undefined) { lLanguage = resultContent.storiesLanguage; }
                      if (resultContent.storiesSortNumber !== undefined) { lNumber = resultContent.storiesSortNumber; }
                      if (resultContent.storiesMessage !== undefined) {
                        lMessage = ReplaceText(resultContent.storiesMessage);
                      }
                      
                      if (resultContent.status !== undefined) {
                        lStatus = resultContent.status === global.config.storiesinStatus[0] ? "Inactive" : "Active";
                      }
                      this.setState({
                          activelink: currpage,
                          paramlink: "inc",
                          stTitle: GetText() ? "Tambah Kisah Sukses" : "Add Success Stories",
                          stories_docid: "",
                          stories_name: lName,
                          stories_email: lEmail,
                          stories_position: lPosition,
                          stories_company: lCompany,
                          stories_type: lType,
                          stories_message: lMessage,
                          stories_status: lStatus,
                          stories_language: lLanguage,
                          stories_number: lNumber,
                          stories_in_docid: resJson.values[0].docid,
                          stories_in_content: JSON.stringify(resultContent),
                          formErrors: {stories_name: '', stories_email: '', stories_position: '', stories_company: '', stories_type: '', stories_message:'', stories_status: "", stories_language: '', stories_number: ''},
                          storiesnameValid: false,
                          storiesemailValid: false,
                          storiespositionValid: false,
                          storiescompanyValid: false,
                          storiestypeValid: false,
                          storiesmessageValid: false,
                          storiesstatusValid: false,
                          storieslanguageValid: false,
                          storiesnumberValid: false,
                          formValid: false,
                      }) 
                    } else {
                      window.location.href=global.config.urlCms+"/"+currpage+"/add";
                    }
                  } else {
                    console.log('Something wrong happened');
                  }
                }).catch(err => err);
        } else {
          this.setState( prevState => {
            return {
              ...prevState.activelink, activelink: currpage,
              ...prevState.paramlink, paramlink: "inc",
              ...prevState.stTitle, stTitle:  GetText() ? "Tambah Kisah Sukses" : "Add Success Stories",
            }
          })
        }
      } else if(typelink === 'add') {
          this.setState( prevState => {
              return {
                ...prevState.activelink, activelink: currpage,
                ...prevState.paramlink, paramlink: docid,
                ...prevState.stTitle, stTitle:  GetText() ? "Tambah Kisah Sukses" : "Add Success Stories",
              }
          })
      }    
  }
  componentDidMount() {
    var urlpath = window.location.pathname;
    if(urlpath.substring(urlpath.length-1,urlpath.length) === "/") {
      urlpath = urlpath.substring(0,urlpath.length-1);
    }
    var arrUrl = urlpath.split("/");
    
    var tabKey="", tabKey2="", docId="";
    if(arrUrl.length===4 && arrUrl[arrUrl.length-1] !== "") {
      tabKey = arrUrl[arrUrl.length-2];
      tabKey2 = arrUrl[arrUrl.length-1];
    } else if(arrUrl.length===5 && arrUrl[arrUrl.length-1] !== "") {
        tabKey = arrUrl[arrUrl.length-3];
        tabKey2 = arrUrl[arrUrl.length-2];
        docId = arrUrl[arrUrl.length-1];
    }
    if(tabKey === "") {
      this.setState({
          activelink: "pnf",
          stTitle : (tabKey2 === "add")? "Add " : (tabKey2 === "edit") ? "Edit " : ""
        });
    } else {
      this.loadData(tabKey,tabKey2,docId);
    }
    
  }

  render() {
    return (
      <div className="setting">
       <Container>
        { (this.state.activelink === "pnf")? 
          <Error404 />
          : 
          (localStorage.getItem("ulvl") === global.config.userLevel[0] || localStorage.getItem("ulvl") === global.config.userLevel[2])? 
          (<>
            <div className="row py-5 mb-5">
              {/* === start - body */}
                <div className="col-md-3 bg-light">
                  { 
                    (this.state.activelink !== "none") && 
                      <MenuLeftCMS value={{tabkey:this.state.activelink}}/>
                  
                  }
                </div>
                <div className="col-md-9 p-4">
                  <div className="row">
                    <div>
                      <h3 className="mb-4">{GetText() ? "Kisah Sukses" : "Success Stories"}</h3>
                    </div>
                    <div className="mt-3">
                      <div className="row show">
                          <div className="col-6"><h5>{this.state.stTitle} </h5></div>
                          <div className="col-6 d-flex justify-content-end">
                             <Button variant="secondary" size="sm" onClick={this.handleBack.bind(this, this.state.activelink, this.state.paramlink)}>&#9664; back</Button>
                          </div>
                      </div>
                      <div className="row mt-3">
                            <form onSubmit={this.handleSubmit}>
                                <div >
                                    <input type="hidden" required name="tutor_docid" value={this.state.stories_docid}/>
                                </div>
                                <div className="row mt-3">
                                    <label className="col-md-3" htmlFor="stories_language">Language</label>
                                    <div className="col-md-9">
                                        <select name="stories_language" className="form-control" 
                                            value={this.state.stories_language} 
                                            onChange={this.handleUserSelect}
                                            ref={(input) => this.textInputStoriesLanguage = input}
                                            disabled={this.state.input_disabled}
                                        >
                                            <option value="" key="L">-- please select --</option>
                                            <option value="English" key="en">English</option>
                                            <option value="Indonesian" key="id">Indonesian</option>
                                        </select>
                                        <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.stories_language}/>  }</div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <label className="col-md-3" htmlFor="stories_type">Type</label>
                                    <div className="col-md-9">
                                        <select name="stories_type" className="form-control" 
                                            value={this.state.stories_type} 
                                            onChange={this.handleUserSelect}
                                            ref={(input) => this.textInputStoriesType = input}
                                            disabled={this.state.input_disabled}
                                        >
                                            <option value="" key="T">-- please select --</option>
                                            <option value="Novaio-Academy" key="TNA">Novaio-Academy</option>
                                            {
                                              global.config.specialCategory.map((item, j) => {
                                                return (
                                                  <option value={item.value} key={"T"+j}>{item.value}</option>
                                                )
                                              })
                                            }
                                            
                                        </select>
                                        <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.stories_type}/>  }</div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <label className="col-md-3" htmlFor="stories_number">Sort Number</label>
                                    <div className="col-md-9">
                                        <input type="number" className="form-control" name="stories_number"
                                                placeholder={this.state.stories_number}
                                                value={this.state.stories_number}
                                                onChange={this.handleUserInput}  
                                                ref={(input) => this.textInputStoriesNumber = input}
                                                min="0"/>
                                        <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.stories_number}/>  }</div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <label className="col-md-3" htmlFor="stories_name">Name</label>
                                    <div className="col-md-9">
                                        <input type="text" className="form-control" name="stories_name"
                                                placeholder={this.state.stories_name}
                                                value={this.state.stories_name}
                                                onChange={this.handleUserInput}  
                                                ref={(input) => this.textInputStoriesName = input}/>
                                        <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.stories_name}/>  }</div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <label className="col-md-3" htmlFor="stories_email">Email</label>
                                    <div className="col-md-9">
                                        <input type="text" className="form-control" name="stories_email"
                                                placeholder={this.state.stories_email ? this.state.stories_email : ''}
                                                value={this.state.stories_email ? this.state.stories_email : ''}
                                                onChange={this.handleUserInput}
                                                ref={(input) => this.textInputStoriesEmail = input}/>
                                        <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.stories_email}/>  }</div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <label className="col-md-3" htmlFor="stories_position">Position / Job Title</label>
                                    <div className="col-md-9">
                                        <input type="text" className="form-control" name="stories_position"
                                                placeholder={this.state.stories_position ? this.state.stories_position : ''}
                                                value={this.state.stories_position ? this.state.stories_position : ''}
                                                onChange={this.handleUserInput}
                                                ref={(input) => this.textInputStoriesPosition = input}/>
                                        <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.stories_position}/>  }</div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <label className="col-md-3" htmlFor="stories_company">Company</label>
                                    <div className="col-md-9">
                                        <input type="text" className="form-control" name="stories_company"
                                                placeholder={this.state.stories_company ? this.state.stories_company : ''}
                                                value={this.state.stories_company ? this.state.stories_company : ''}
                                                onChange={this.handleUserInput}
                                                ref={(input) => this.textInputStoriesCompany = input}/>
                                        <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.stories_company}/>  }</div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <label className="col-md-3" htmlFor="stories_message">Message</label>
                                    <div className="col-md-9">
                                        <textarea name="stories_message" className="form-control" 
                                                rows={5} cols={30} 
                                                value={this.state.stories_message} 
                                                onChange={this.handleUserInput} 
                                                ref={(input) => this.textInputStoriesMessage = input}/>
                                        <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.stories_message}/>  }</div>
                                    </div>
                                </div>
                                
                                <div className="row mt-3">
                                    <label className="col-md-3" htmlFor="stories_status">Status</label>
                                    <div className="col-md-9">
                                        <select name="stories_status" className="form-control" 
                                            value={this.state.stories_status} 
                                            onChange={this.handleUserSelect}
                                            ref={(input) => this.textInputStoriesStatus = input}
                                            disabled={this.state.input_disabled}
                                        >
                                            <option value="" key="S">-- please select --</option>
                                            <option value="Active" key="status_active">Active</option>
                                            <option value="Inactive" key="status_inactive">Inactive</option>
                                        </select>
                                        <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.stories_status}/>  }</div>
                                    </div>
                                </div>
                                <div className="row mt-4 mb-3">
                                    <div className="col-md-3"></div>
                                    <div className="col-md-9"><Button type="submit" variant="secondary">Submit</Button></div>
                                </div>
                            </form>
                      </div>
                    </div>
                  </div>
                </div>
              {/* === end - body */}
            </div>
            
            </>
          )
        : 
          <div><CTNA/></div>
        }
        <div id="loading-area" className="d-none loading"></div> 
        </Container>
      </div>
    );
  }
}
